import { z } from "zod";

export const StationsSchema = z
  .array(
    z.object({
      id: z.string(),
      name: z.string(),
      jbvid: z.string(),
    }),
  )
  .default([]);
